import { Color, Radius, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    padding: Spacing.XXL,
    alignItems: 'center',
  },
  text: {
    textAlign: 'center',
    marginBottom: Spacing.M,
  },
})

interface Props extends ViewProps {}

const LoggingEmpty = (props: Props) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.text}>
        <Trans>There are no log messages yet.</Trans>
      </Text>
    </View>
  )
}

export default LoggingEmpty
